import BoxMessage from "shared/components/box/BoxMessage.js";
import ItemRowPlayerAssist from "shared/components/items/ItemRowPlayerAssist.js";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import ButtonPlayerView from "shared/components/buttons/ButtonPlayerView.js";
import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { getPlayers } from "shared/services/api-assistant.js";

interface PopupPlayersProps {
  trigger: Object;
  onClose: func;
  filters?: Object;
  open?: Boolean;
}

const PopupPlayers: React.FC<PopupPlayersProps> = ({ trigger, onClose, filters, open }) => {
  const [page, setPage] = useState(1);
  const [players, setPlayers] = useState(null);
  const [playerView, setPlayerView] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [canLoadMore, setCanLoadMore] = useState(false);

  const fetchPlayers = () => {
    setIsLoading(true);

    if (page === 1) {
      setPlayers(null);
    }

    getPlayers({
      handleSuccess: (v) => {
        if (page === 1) {
          setPlayers(v.data.getPlayers);
        } else {
          setPlayers(players ? players.concat(v.data.getPlayers) : v.data.getPlayers);
        }

        setIsLoading(false);
        setCanLoadMore(v.data.getPlayers.length === 50);
        setPage(page + 1);
      },
      params: {
        ...filters,
        limit: 50,
        skip: 50 * (page - 1),
      },
    });
  };

  const loadMore = () => {
    fetchPlayers(Math.round(players.length / 50) + 1);
  };

  useEffect(() => {
    if (open) {
      setPlayers(null);
      setPage(1);
      fetchPlayers();
    }
  }, [open]);

  const onPopupClose = () => {
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setPlayers(null);
    setPage(1);
  }, [filters]);

  return (
    <div className="PopupAddPlayers">
      <Popup
        trigger={trigger}
        modal
        open={open}
        closeOnDocumentClick={false}
        onClose={onPopupClose}
        className={"fade-in popup-xl"}
      >
        {(close) => (
          <div>
            <div className="d-flex flex-row flex-grow-0 mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">Players</h2>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-grow-0 justify-content-end mb-3">
              <ButtonPlayerView selectedView={playerView} onChange={(v) => setPlayerView(v)} />
            </div>

            <div className="d-flex flex-column flex-grow-1 overflow-auto">
              <div className="d-flex flex-grow-1 flex-column overflow-auto">
                {players &&
                  players.length > 0 &&
                  players.map((p) => (
                      <ItemRowPlayerAssist p={p} display={playerView} />
                  ))}

                {players && players.length === 0 && <BoxMessage content={"No player found"} />}

                {!players && (
                  <div style={{ height: "200px" }}>
                    <LoadingSquare />
                  </div>
                )}

                {players && isLoading && (
                  <div style={{ height: "30px" }}>
                    <LoadingSquare />
                  </div>
                )}

                {canLoadMore && !isLoading && (
                  <button className="btn btn-sm btn-link align-self-start" onClick={() => loadMore()}>
                    Load more
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupPlayers;
